/**
 * Created by ganlu on 27/12/2016.
 */
class FancyboxController {
    constructor() {
    }
}

export default FancyboxController;



// WEBPACK FOOTER //
// ./src/app/modules/fancybox-plus/fancybox.controller.js